import React from 'react'
import { RichText, Elements } from 'prismic-reactjs';

import './RichTextComponent.scss'

export default function RichTextComponent(props){
  const {
    data,
    prismicCtx
  } = props


	
  const propsWithUniqueKey = function(props, key) {
    return Object.assign(props || {}, { key });
  };
   
  // -- HTML Serializer
  const htmlSerializer = function(type, element, content, children, key) {
    var props = {};
   
    switch(type) {
        
      case Elements.heading1: // Heading 1
        return <h2 key={key} className='rich__h1'>{children}</h2>
        
      case Elements.heading2: // Heading 2
        return <h2 key={key} className='rich__h2'>{children}</h2>
        
      case Elements.heading3: // Heading 3
        return <h2 key={key} className='rich__h3'>{children}</h2>  

      case Elements.heading4: // Heading 4
        return <h4 key={key} className='rich__h4'>{children}</h4>
        
      case Elements.heading5: // Heading 5
        return <h5 key={key} className='rich__h5'>{children}</h5>
        
      case Elements.heading6: // Heading 6
        return <h6 key={key} className='rich__h6'>{children}</h6>
        
      case Elements.paragraph: // Paragraph
        return <p key={key} className='rich__p'>{children}</p>
        
      case Elements.preformatted: // Preformatted
        return <pre key={key} className='rich__pre'>{children}</pre>
        
      case Elements.strong: // Strong
        return <strong key={key} className='rich__strong'>{children}</strong>
        
      case Elements.em: // Emphasis
        return <em key={key} className='rich__em'>{children}</em>
        
      case Elements.listItem: // Unordered List Item
        return <li key={key} className='rich__li'>{children}</li>
        
      case Elements.oListItem: // Ordered List Item
        return <li key={key} className='rich__li'>{children}</li>
        
      case Elements.list: // Unordered List
        return (<ul key={key} className='rich__ul'>{children}</ul>)
        
      case Elements.oList: // Ordered List
        return (<ol key={key} className='rich__ol'>{children}</ol>)
        
      case Elements.image: // Image
        const linkUrl = element.linkTo ? element.linkTo.url || prismicCtx.linkResolver(element.linkTo) : null;
        const linkTarget = (element.linkTo && element.linkTo.target) ? { target: element.linkTo.target } : {};
        const linkRel = linkTarget.target ? { rel: 'noopener' } : {};
        const img = React.createElement('img', { style: {width: '100%', borderRadius: 5}, src: element.url , alt: element.alt || '' });
        return React.createElement(
          'p',
          propsWithUniqueKey({ style: {width: '100%'},className: [element.label || '', 'block-img'].join(' ') }, key),
          linkUrl ? React.createElement('a', Object.assign({ href: linkUrl }, linkTarget, linkRel), img) : img
        );
        
      case Elements.embed: // Embed
        props = Object.assign({
          
          "data-oembed": element.oembed.embed_url,
          "data-oembed-type": element.oembed.type,
          "data-oembed-provider": element.oembed.provider_name,
        }, element.label ? {className: element.label} : {});
        const embedHtml = React.createElement('div', {style: {width: '100%', display: 'flex', justifyContent: 'center', },dangerouslySetInnerHTML: {__html: element.oembed.html, title: "Test"}});
        return React.createElement('div', propsWithUniqueKey(props, key), embedHtml);
        
      case Elements.hyperlink: // Link
        const targetAttr = element.data.target ? { target: element.data.target } : {};
        const relAttr = element.data.target ? { rel: 'noopener' } : {};
        props = Object.assign({ 
          href: element.data.url || prismicCtx.linkResolver(element.data)
        }, targetAttr, relAttr, {target: '_blank'});
        return React.createElement('a', propsWithUniqueKey({className: ['rich__link'], ...props}, key), children);
        
      case Elements.label: // Label
        props = element.data ? Object.assign({}, { className: element.data.label }) : {};
        return React.createElement('span', propsWithUniqueKey(props, key), children);
        
      case Elements.span: // Span
        if (content) {
          return content.split("\n").reduce((acc, p) => {
            if (acc.length === 0) {
                return [p]
            } else {
              const brIndex = (acc.length + 1)/2 - 1;
              const br = React.createElement('br', propsWithUniqueKey({}, brIndex));
              return acc.concat([br, p]);
            }
          }, []);
        } else {
          return <br key={'break'}/>;
        }
   
      default: // Always include a default that returns null
        return null;
    }
  };

  return (
    <RichText render={data} htmlSerializer={htmlSerializer} />
  )
}